import { Directive, HostListener, ElementRef, OnInit } from "@angular/core";
import { TrimPipe } from 'angular-pipes/src/string/trim.pipe';

@Directive({ selector: "[trimPlus]" })
export class TrimPlusDirective
{
    private el: HTMLInputElement;
    private trimPipe: TrimPipe;
    constructor( private elementRef: ElementRef ) {
        this.el = this.elementRef.nativeElement;
        this.trimPipe = new TrimPipe();
    }

    @HostListener("blur", ["$event.target.value"])
    onBlur(value) {
        if(value==""){
            this.elementRef.nativeElement.style.backgroundColor = '#fff0f0';
            this.elementRef.nativeElement.style.borderColor = '#A90329';
        }
        else{
            this.el.value = this.trimPipe.transform(value);
            this.elementRef.nativeElement.style.backgroundColor = '#f0fff0';
            this.elementRef.nativeElement.style.borderColor = '#7DC27D';
        }


    }

    /* Cuando presiono tecla */
    @HostListener("keyup", ["$event.target.value"])
    onKeyup(value) {
        var patt = new RegExp('[ ]');
        if((patt.test(value))==true){
            if(value==" "){
                this.elementRef.nativeElement.style.backgroundColor = '#fff0f0';
                this.elementRef.nativeElement.style.borderColor = '#A90329';
            }
            else{
                this.elementRef.nativeElement.style.backgroundColor = '#f0fff0';
                this.elementRef.nativeElement.style.borderColor = '#7DC27D';
            }
        }
        else
        {
            this.elementRef.nativeElement.style.backgroundColor = '#f0fff0';
            this.elementRef.nativeElement.style.borderColor = '#7DC27D';
        }
        this.el.value = value.replace(/^\s+/, "");
    }



}


// WEBPACK FOOTER //
// ./src/app/shared/utils/directives/trimPlus.directive.ts